{
  "AboutPage": {
    "get-listed-description": "想在 Trust Marketplace 上展示您的业务吗？",
    "get-listed-suffix": "开始吧。",
    "get-listed-title": "列入名单",
    "how-description": "商家和个人通过 Raytio 平台验证身份、企业注册信息和资质。每次验证都经过数字签名，并可独立审计，从而形成透明的信任链。",
    "how-title": "验证工作原理",
    "sign-up": "注册 Raytio",
    "title": "关于信任市场",
    "what-is-description": "Raytio Trust Marketplace 是一个公开的、经过验证的商家和服务提供商名录。每个商家信息都经过加密验证，确保您看到的信息真实可靠。",
    "what-is-title": "什么是信任市场？"
  },
  "BookingPage": {
    "book": "书",
    "date-range-label": "下一个",
    "days-label": "天",
    "km-away": "距离 {distance} 公里",
    "location-label": "地点",
    "location-placeholder": "输入郊区或城市……",
    "no-results": "暂无可预约时间。请尝试扩大搜索范围或日期范围。",
    "progress": "已搜索 {completed} 家供应商，共 {total} 家供应商。",
    "radius-label": "之内",
    "search": "搜索",
    "search-failed": "搜索失败，请重试。",
    "search-timed-out": "搜索超时。部分服务提供商可能未响应。",
    "searching": "正在搜索服务提供商……",
    "service-label": "服务",
    "service-placeholder": "选择一项服务……",
    "sign-in-prompt": "使用您的 Raytio 帐户登录以搜索可预约的服务。",
    "sign-in-to-search": "登录进行搜索",
    "sort-closest": "最近的",
    "sort-provider": "按提供商",
    "sort-soonest": "最快",
    "title": "预约",
    "location-permission-denied": "位置权限被拒绝。请改为输入地址。",
    "location-unavailable": "无法确定您的位置。请改为输入地址。",
    "my-location": "我的位置",
    "use-my-location": "使用我的位置",
    "sign-up-prompt": "还没有账户？注册以搜索可用预约。",
    "sign-up-to-search": "注册以搜索",
    "view-list": "List",
    "view-calendar": "Calendar"
  },
  "CategoryFilter": {
    "clear": "Clear",
    "no-results": "No categories found",
    "placeholder": "Filter by category…"
  },
  "CountryFilter": {
    "all-countries": "所有国家",
    "filter-by-country": "按国家/地区筛选"
  },
  "CtaBar": {
    "book": "书",
    "coming-soon": "即将推出"
  },
  "Footer": {
    "about": "关于",
    "powered-by": "供电",
    "privacy": "隐私",
    "terms": "条款"
  },
  "Header": {
    "about": "关于",
    "brand": "Raytio市场",
    "merchants": "商人",
    "services": "服务",
    "sign-in": "登入",
    "sign-out": "登出",
    "sign-up": "注册"
  },
  "HomePage": {
    "subtitle": "发现经过验证的商家和值得信赖的服务提供商。",
    "title": "信任市场",
    "verified-merchants": "已验证商家",
    "view-all": "查看全部"
  },
  "MerchantCard": {
    "unnamed": "无名商人",
    "verified": "已验证"
  },
  "MerchantDetail": {
    "active": "积极的",
    "approved": "得到正式认可的",
    "default-description": "在 Raytio Trust Marketplace 上查看此商家。",
    "forms-heading": "表格",
    "forms-sign-in-button": "登录查看表格",
    "forms-sign-in-prompt": "使用您的 Raytio 帐户登录以查看此商家的表单。",
    "locations": "地点",
    "no-address": "暂无地址",
    "no-forms-available": "暂无表格可供填写",
    "not-found": "未找到商家",
    "primary-use": "基本的",
    "sign-in-prompt": "使用您的 Raytio 帐户登录，即可查看该商户的分支机构详细信息和位置。",
    "sign-in-to-view": "登录查看位置",
    "unnamed": "无名商人",
    "forms-sign-up-button": "注册以查看表单",
    "forms-sign-up-prompt": "还没有账户？注册以访问此商家的表单。"
  },
  "MerchantsPage": {
    "no-merchants": "未找到商家。",
    "subtitle": "浏览经过验证的商家和值得信赖的服务提供商。",
    "title": "商家名录"
  },
  "SearchBar": {
    "placeholder": "搜索商家……"
  },
  "ServiceCategoryFilter": {
    "no-results": "未找到任何类别",
    "placeholder": "跳转至服务类别…"
  },
  "ServiceCategoryPage": {
    "breadcrumb-services": "服务",
    "no-merchants": "未找到提供此服务的供应商。",
    "not-found": "未找到服务",
    "search-placeholder": "搜索服务提供商……",
    "sign-in-prompt": "使用您的 Raytio 帐户登录，即可查看提供此服务的供应商。",
    "sign-in-to-view": "登录查看服务提供商",
    "sign-up-prompt": "还没有账户？注册以查看此服务的提供商。",
    "sign-up-to-view": "注册以查看提供商"
  },
  "ServiceItemAttributes": {
    "no-data": "暂无属性数据。"
  },
  "ServiceMerchantPage": {
    "breadcrumb-services": "服务",
    "hide-details": "隐藏详情",
    "items-title": "产品与服务",
    "no-items": "未列出任何产品或服务。",
    "not-found": "未找到",
    "show-details": "显示详情"
  },
  "ServicesPage": {
    "no-services": "暂无服务可用。",
    "services-count": "{count, plural, one {#项服务} other {#项服务}}",
    "subtitle": "按类别浏览服务。",
    "title": "服务"
  },
  "ThemeToggle": {
    "dark-mode": "切换到深色模式",
    "light-mode": "切换到浅色模式"
  },
  "Persona": {
    "issued": "Issued",
    "expires": "Expires",
    "last-verified": "Last verified",
    "self-asserted-note": "Name and bio are self-asserted and unverified",
    "profile-url": "Profile",
    "claim-verification": "Verification",
    "claim-reputation": "Reputation",
    "section-verifications": "Verifications",
    "section-social": "Connected Accounts",
    "section-reputation": "Reputation",
    "section-other": "Other Claims",
    "no-claims": "This profile has no published claims yet.",
    "rating": "Rating",
    "activity": "Activity",
    "member-since": "Member since",
    "not-found-title": "Profile Not Found",
    "not-found-description": "The requested profile could not be found.",
    "canonical-payload": "已签名数据",
    "signature": "签名",
    "signing-key": "签名密钥",
    "verify": "验证签名",
    "verifying": "验证中…",
    "verify-valid": "签名有效",
    "verify-invalid": "签名不匹配",
    "verify-no-key": "未记录签名密钥 — 无法验证",
    "verify-error": "无法获取签名密钥",
    "signed": "Signed",
    "verified": "Verified",
    "view-signed-data": "View signed data",
    "hide-signed-data": "Hide signed data",
    "verify-again": "Verify again",
    "try-again": "Try again",
    "verify-valid-detail": "Checked in your browser against Raytio's published key.",
    "verify-valid-caveat": "A valid signature proves Raytio asserted this — not that it is true or complete.",
    "verify-invalid-detail": "This claim may have been altered.",
    "trust-note": "Each signed claim below carries an RSA-PSS signature from Raytio. Expand one to read the exact bytes that were signed and check them in your own browser — you don't have to take this page's word for anything.",
    "attested-claims-title": "Attested claims",
    "claims-summary": "{count, plural, one {# signed by Raytio · check it yourself} other {# signed by Raytio · check any of them yourself}}",
    "open-profile": "Open profile",
    "trust-note-label": "About attested claims",
    "reputation-note": "Bucketed on purpose — Raytio never publishes exact counts.",
    "stat-activity": "Activity",
    "stat-as-buyer": "As buyer",
    "stat-as-seller": "As seller",
    "stat-reviews": "Reviews",
    "stat-none-yet": "None yet",
    "reputation-note-label": "About these figures"
  },
  "Calendar": {
    "day": "Day",
    "week": "Week",
    "month": "Month",
    "today": "Today",
    "prev": "Previous",
    "next": "Next",
    "all": "All",
    "book": "Book",
    "close": "Close",
    "move": "Move detail window",
    "move-reset": "Move detail window (double-click to snap back)",
    "no-slots-day": "No available slots for this day.",
    "more-slots": "+{count} more",
    "slot-count": "{count, plural, one {# slot} other {# slots}}"
  },
  "BuyPage": {
    "title": "选择您的使用时段",
    "slot-label": "槽位 {slotNumber}",
    "choose-duration": "选择时长",
    "in-use-title": "此槽位正在使用中",
    "in-use-body": "此槽位当前有一个进行中的会话。请稍后再试。",
    "halted-title": "购买进行中",
    "halted-body": "有人正在完成此槽位的购买。请稍候片刻后重试。",
    "no-options": "此槽位暂无可用选项。"
  }
}
